import React from 'react';
import { FullPrayerHub } from '@api/routes/prayer-hubs/get/params';

import css from './encouragement-message.module.scss';

interface Props {
  encouragementMsgContainerRef: React.RefObject<HTMLDivElement>;
  content?: FullPrayerHub['encouragementMessage'];
}

export const EncouragementMessage: React.FC<Props> = ({ encouragementMsgContainerRef, content }) => {
  return (
    <div ref={encouragementMsgContainerRef} className={css.encouragementMsg}>
      <div className={css.content}>{content?.text.he ?? ''}</div>
    </div>
  );
};
